import { useMemo, useState } from 'react';
import { SimpleBar } from '@shared/components/simpleBar/simpleBar';
import { toISODateFormat } from '@shared/utils/dateFormatters';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { SettingsOutletHeader } from '../shared/SettingsOutletHeader';
import { useSettingsOutletScroll } from '../shared/useSettingsOutletScroll';
import { FinancesFilters } from './FinancesFilters';
import { DateFilterOption, getFinancesDateRange } from './dateRange';
import { FinancesOverview } from './FinancesOverview';
import styles from './FinancesPage.scss';

export const FinancesPage = () => {
  const restaurant = useRestaurant();
  const { timezone } = restaurant;
  const [dateFilter, setDateFilter] = useState(DateFilterOption.YearToDate);
  const [customStartDate, setCustomStartDate] = useState(
    toISODateFormat(new Date()),
  );
  const [customEndDate, setCustomEndDate] = useState(
    toISODateFormat(new Date()),
  );
  const [compareEnabled, setCompareEnabled] = useState(true);

  const { bodyScrollHostRef, bodyScrollHostStyle } = useSettingsOutletScroll({
    enabled: !!restaurant,
  });

  const dateRange = useMemo(
    () =>
      getFinancesDateRange({
        filter: dateFilter,
        timezone,
        customRange:
          dateFilter === DateFilterOption.CustomRange
            ? { startDate: customStartDate, endDate: customEndDate }
            : undefined,
      }),
    [customEndDate, customStartDate, dateFilter, timezone],
  );

  return (
    <div className={styles.root}>
      <SettingsOutletHeader
        subtitle="Earnings overview"
        title="Financial Dashboard"
      />

      <FinancesFilters
        compareEnabled={compareEnabled}
        customEndDate={customEndDate}
        customStartDate={customStartDate}
        dateFilter={dateFilter}
        onCompareToggle={setCompareEnabled}
        onCustomEndDateChange={setCustomEndDate}
        onCustomStartDateChange={setCustomStartDate}
        onDateFilterChange={setDateFilter}
      />

      <div
        ref={bodyScrollHostRef}
        className={styles.bodyScrollHost}
        style={bodyScrollHostStyle}
      >
        <SimpleBar className={styles.bodyScroll}>
          <div className={styles.content}>
            <FinancesOverview
              compareEnabled={compareEnabled}
              dateFilter={dateFilter}
              dateRange={dateRange}
            />
          </div>
        </SimpleBar>
      </div>
    </div>
  );
};
